import { render, staticRenderFns } from "./projectTable.vue?vue&type=template&id=42a51e72&scoped=true"
import script from "./projectTable.vue?vue&type=script&lang=js"
export * from "./projectTable.vue?vue&type=script&lang=js"
import style0 from "./projectTable.vue?vue&type=style&index=0&id=42a51e72&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a51e72",
  null
  
)

export default component.exports